var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nowtime"},[_c('div',{attrs:{"id":"time"}},[_vm._v(_vm._s(_vm.monAndDate)+" "+_vm._s(_vm.week))])])}
var staticRenderFns = []

export { render, staticRenderFns }